/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {AnyData} from '../api/';
import {isBlank, isPresent} from '../utils/lang';

@Pipe({name: 'gpEmployeeId', pure: false})
export class EmployeeIdPipe implements PipeTransform {

  public transform(data: AnyData): string {
    if (!isPresent(data)) {
      return;
    }
    if (isPresent(data.attributes)) {
      if (!isBlank(data.attributes.employeeNumber)) {
        return data.attributes.employeeNumber;
      }
      if (!isBlank(data.attributes.otherid1)) {
        return data.attributes.otherid1;
      }
    }
    return data.id;
  }
}
